var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEye = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.167
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.203 7.203a.583.583 0 0 1 0-.406 6.27 6.27 0 0 1 11.594 0 .584.584 0 0 1 0 .406 6.271 6.271 0 0 1-11.594 0Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 8.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z"
}))));
SvgEye.viewBox = '0 0 14 14';
const ForwardRef = /*#__PURE__*/forwardRef(SvgEye);
export default ForwardRef;